import * as React from 'react';
import styled from 'styled-components';
import { forIE } from '@westwing/ui-kit/breakPoints';
import { POKey } from './constants';
import * as Styled from './LooksInfusionSlider.styles';
import { useGaTracking } from './useTracking';
import useBellaTranslator from 'Client/hooks/useTranslator';
import { useBellaDispatch } from 'Client/redux/hooks';
import GenericHybridLink from 'Client/components/Generic/Links/HybridLink';
import { BellaTestIds } from 'Common/qaIds';
import { setLDPKnownInfoAction } from 'Client/redux/lookDetail/actions';
import { Look } from 'Client/redux/productLooks/types';

const HybridLink = styled(GenericHybridLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.charcoal3};
    color: ${({ theme }) => theme.colors.charcoal100};
    text-align: center;

    ${forIE`
        margin-left: 10px;
        height: 506px;
        min-width: 300px;
    `}
`;

const LastTile = ({ look }: { look: Look }) => {
    const t = useBellaTranslator();
    const dispatch = useBellaDispatch();

    const { trackLookInfusionClicks } = useGaTracking();

    return (
        <HybridLink
            to={`/looks/${look.slug}/`}
            onClick={() => {
                dispatch(setLDPKnownInfoAction(look));
                trackLookInfusionClicks('See all looks tile');
            }}
            testId={BellaTestIds.pdpLooksInfusionLastTile}
        >
            <Styled.Headline as="h3">{t(POKey.LAST_TILE_HEADLINE_LOOKS_INFUSION)}</Styled.Headline>
            <Styled.CTALink as="div">{t(POKey.LAST_TILE_CTA_LOOKS_INFUSION)}</Styled.CTALink>
        </HybridLink>
    );
};

export default LastTile;
